import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import {
  FormikField,
  getFormikFormFieldErrorProps,
} from '../../../../../../Formik'
import Text from '../../../../../../Text'
import { TextareaOutlineField } from '../../../../../../Textarea'
import {
  APPLICANT_CHECKLIST_REJECT_REASON_MAX_LENGTH,
  QA_NAME_APPLICANT_CHECKLIST_REJECT_REASON,
} from '../../ApplicantDocumentChecklist.constants'
import {
  APPLICANT_DOCUMENT_REJECT_FIELD_MIN_ROWS,
  APPLICANT_DOCUMENT_REJECT_FIELD_NAME,
} from '../ApplicantDocumentRejectModal.constants'

import * as styles from './ApplicantDocumentRejectModalFields.module.css'

function ApplicantDocumentRejectModalFields({ description }) {
  const { t } = useTranslation()

  const reasonRef = useRef(null)

  useEffect(() => {
    reasonRef.current?.focus()
  }, [])

  return (
    <div className={styles.ApplicantDocumentRejectModalFields}>
      <Text>{description}</Text>
      <FormikField
        withoutManualResize
        Component={TextareaOutlineField}
        elementRef={reasonRef}
        getErrorProps={getFormikFormFieldErrorProps}
        maxLength={APPLICANT_CHECKLIST_REJECT_REASON_MAX_LENGTH}
        minRows={APPLICANT_DOCUMENT_REJECT_FIELD_MIN_ROWS}
        name={APPLICANT_DOCUMENT_REJECT_FIELD_NAME}
        placeholder={t(
          'RentalPortal.ApplicantDocumentRejectReasonPlaceholderKey'
        )}
        qaName={QA_NAME_APPLICANT_CHECKLIST_REJECT_REASON}
      />
    </div>
  )
}

export default ApplicantDocumentRejectModalFields
